const defaultAddedUser = {
  role: 'user',
  phoneNumber: '+1',
};
const addedUser = (state = defaultAddedUser, action) => {
  switch (action.type) {
    case 'ADD_USER_CHANGE':
      return {
        ...state,
        ...{ [action.name]: action.value },
      };
    case 'ADD_USER_RESET':
      return defaultAddedUser;
    default:
      return state;
  }
};

export default addedUser;
